import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { Typography, TextField, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
  },
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  itemInput: {
    width: '240px',
  },
}));

const SelectAreaGroup = props => {
  const { 
    className, 
    areas,
    groups,
    valueArea,
    onChangeArea, 
    valueGroup,
    //onSetValueGroup,
    onChangeGroup, 
    style, 
    ...rest } = props;

  const classes = useStyles();

  // const [areaGroups, setAreaGroups] = useState([]);

  // const handleChangeArea = (e) => {
  //   let newAreaGroups = groups.filter(group => group.area === e.target.value);
  //   console.log('new groups ->');
  //   console.log(newAreaGroups);
  //   setAreaGroups(newAreaGroups);
  //   onSetValueGroup('');
  //   onChangeArea(e);
  // }

  // useEffect(() => {
  //   //console.log('componentDidUpdate & selectedTemplates changed');
  //   //setAgencyClients([]);
  // }, [agencies]);

  return (
    <div className={classes.row}>

      <TextField
        className={classes.itemInput}
        id="outlined-select-area"
        required 
        select
        label="권역"
        value={valueArea}
        onChange={onChangeArea}
        helperText=""
        //variant="outlined"
        margin="dense"
      >
        {areas.map(option => (
          <MenuItem key={option.id} value={option.name}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>

      <div style={{width: 36}}>

      </div>

      <TextField
        className={classes.itemInput}
        id="outlined-select-group"
        required 
        select
        label="그룹"
        value={valueGroup}
        onChange={onChangeGroup}
        helperText=""
        //variant="outlined"
        margin="dense"
        helperText="* 권역선택후 선택하세요"
      >
        {groups.map(option => (
          <MenuItem key={option.id} value={option.name}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>

    </div>
  );
};

SelectAreaGroup.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SelectAreaGroup;
